/**
 * ClientApiAuto (axios) cagrilarinin hata bildirimi, tek yerde.
 *
 * 401 ve 403 OtherApis'teki ortak yakalayicida zaten isleniyor (oturum dusurme / yetki uyarisi);
 * geri kalan hatalar burada toast'lanir. Sunucu IsSuccess=false dondugunde mesaj zarfin icinde
 * gelir ve exception firlamaz; onun icin ayri yardimci var.
 */
export function toastApiError(e: any): void {
  if (e && (e.statusCode === 401 || e.statusCode === 403)) return;
  toastr.error(e && typeof e.message === 'string' ? e.message : 'Error');
}

export function toastResultError(result: { Message?: string | null } | undefined): void {
  toastr.error(result && result.Message ? result.Message : 'Error');
}
